import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth-service';

@Component({
    templateUrl: './sign-in-silent.component.html',
    standalone: false
})
export class SignInSilentComponent implements OnInit {
    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.authService.userManager.signinSilentCallback();
    }
}
